import { Box, Button, CircularProgress } from "@material-ui/core";
import { Form, Formik } from "formik";
import { FormattedMessage } from "react-intl";
import clsx from "clsx";
import { MyTextField } from "../../../../../components/custom/MyTextField";
import useMiaForm from "./useMiaForm";

function MiaForm() {
  const { classes, initialValues, submit, intl, validationSchema } =
    useMiaForm();

  return (
    <Box marginRight={"0.5rem"}>
      <Formik
        validateOnChange={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        valida
        onSubmit={submit}
      >
        {({ isSubmitting }) => (
          <Form>
            <label className={classes.title}>
              <FormattedMessage id="miaUrl" />*
            </label>
            <MyTextField
              name="miaUrl"
              placeholder={intl.formatMessage({ id: "miaUrl" })}
              type="text"
              variant="outlined"
              className={classes.myTextFieldRoot}
            />
            <Box mt={5} display="flex" justifyContent={"center"}>
              <Button
                className={clsx(classes.btn, classes.save)}
                autoFocus
                type={"submit"}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <CircularProgress className={classes.btnLoading} />
                ) : (
                  <FormattedMessage id="Save" />
                )}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}

export default MiaForm;
